import React, { useState, useRef } from "react";
import RowBody from "./RowBody";
import Loader from "../../components/Loader/Loader";
import { Dialog } from "primereact/dialog";
import NoDataFound from "../../components/NoDataFound/NoDataFound";
import { Splitter, SplitterPanel } from "primereact/splitter";
import { Button } from "primereact/button";
import http from "../../../src/Redux/services/http-common.jsx";
import { data } from "autoprefixer";
import { Toast } from "primereact/toast";
// import { Document, Page, pdfjs } from "react-pdf";
function MedicineOrderList({
  medicineList,
  doctorConsultation,
  isLoader,
  fetchList,
}) {
  console.log(medicineList, "cfghjklhbjkmll");
  const toast = useRef(null);
  const [isVisible, setIsVisible] = useState(false);
  const [fileType, setFileType] = useState("");
  const [fileUrl, setFileUrl] = useState("");
  const [fileUrl1, setFileUrl1] = useState("");
  const [isVerified, setIsVerified] = useState(null);
  const [acceptClicked, setAcceptClicked] = useState({});

  const [smartDoc, setSmartDoc] = useState({
    id: "",
    smartDoc: [],
    patientCode: "",
  });

  const handleViewClick = (originalDoc, smartDoc, id, patientCode, isVerifiedVal, smartReportDoc) => {
    setFileUrl(originalDoc);
    setIsVerified(isVerifiedVal);
    if (isVerifiedVal === 1) {
      setFileUrl1(smartReportDoc);
    }
    let format = JSON.parse(smartDoc);
    console.log(format, "ghhh")

    setSmartDoc({
      id,
      smartDoc: format[0].data,
      patientCode: patientCode,
      dateTime: format[0]?.date_time?.[0] || {
        collection_date_time: "",
        received_date_time: ""
      }
    });

    setIsVisible(true);
    if (originalDoc) {
      const extension = originalDoc.split(".").pop().toLowerCase();
      if (["png", "jpg", "jpeg", "gif", "webp"].includes(extension)) {
        setFileType("image");
      } else if (extension === "pdf") {
        setFileType("pdf");
      } else {
        setFileType("unknown");
      }
    }
  };

  console.log(smartDoc, "sdihvdsihvsdouvdsvds");

  const handleInputChange = (index, field, value) => {
    const updatedData = smartDoc.smartDoc.map((row, i) =>
      i === index ? { ...row, [field]: value } : row
    );
    setSmartDoc({ ...smartDoc, smartDoc: updatedData });
  };

  const handleAccept = () => {
      const currentId = smartDoc.id;
       setAcceptClicked((prev) => ({ ...prev, [currentId]: true }));
    let payload = {
      id: smartDoc.id,
      isVerified: 1,
      patientCode: smartDoc.patientCode,
    };
    http
      .put(
        `${process.env.REACT_APP_BASEURL}backoffice/patientDocument/updateDoc/`,
        payload
      )
      .then((response) => {
        toast.current.show({
          severity: "success",
          summary: "Success",
          detail: "Status Updated",
          life: 3000,
        });
        setIsVisible(false);
        fetchList();
      })
          .catch(() => {
             setAcceptClicked((prev) => ({ ...prev, [currentId]: false }));
    
    });
  };

  const handleReject = () => {
    let payload = {
      id: smartDoc.id,
      isVerified: 2,
      patientCode: smartDoc.patientCode,
    };
    http
      .put(
        `${process.env.REACT_APP_BASEURL}backoffice/patientDocument/updateDoc/`,
        payload
      )
      .then((response) => {
        toast.current.show({
          severity: "success",
          summary: "Success",
          detail: "Status Updated",
          life: 3000,
        });
        setIsVisible(false);
        fetchList();
      });
  };



  const handleUpdate = () => {
    const payload = {
      id: smartDoc.id,
      patientCode: smartDoc.patientCode,
      smartDoc: JSON.stringify([
        {
          date_time: [smartDoc.dateTime],
          data: smartDoc.smartDoc,
        },
      ]),
    };

    console.log(payload, "Final Payload to API");

    http
      .put(
        `${process.env.REACT_APP_BASEURL}backoffice/patientDocument/updateDoc/`,
        payload
      )
      .then((response) => {
        toast.current.show({
          severity: "success",
          summary: "Success",
          detail: "Updated Successfully",
          life: 3000,
        });
        fetchList();
      });
  };



  const footerContent = () => {
    if (isVerified === 1 || isVerified === 2) return null;
    return (
      <div style={{ marginTop: 10 }}>
        <Button label="Add" severity="info" onClick={handleAddRow} />
        <Button label="Update" severity="warning" onClick={handleUpdate} />
        <Button label="Accept" severity="success" onClick={handleAccept} disabled={acceptClicked[smartDoc.id]} />
        <Button label="Reject" severity="danger" onClick={handleReject} />




      </div>
    );
  };

  const handleAddRow = () => {
    const newRow = { name: "", value: "", unit: "", reference_range: "", flag: "" };
    setSmartDoc({ ...smartDoc, smartDoc: [...smartDoc.smartDoc, newRow] });
  };

  const handleDeleteRow = (index) => {
    const updatedRows = smartDoc.smartDoc.filter((_, i) => i !== index);
    setSmartDoc({ ...smartDoc, smartDoc: updatedRows });
  };


  return (
    <div className="listContainer">
      <Toast ref={toast} />
      <div className="listBorder">
        {doctorConsultation.map((item, i) => (
          <div key={i}>
            <p className="listTitle1">{item} </p>
          </div>
        ))}
      </div>
      <div className="boxMain">
        {medicineList?.map((res) => (
          <RowBody medicineList={res} handleViewClick={handleViewClick} />
        ))}

        {isLoader != false && <Loader />}
      </div>
      <Dialog
        header="Header"
        visible={isVisible}
        style={{ width: "95vw" }}
        onHide={() => {
          if (!isVisible) return;
          setIsVisible(false);
        }}
        footer={footerContent}
      >
        <Splitter>
          <SplitterPanel className="flex align-items-center justify-content-center">
            <h3 style={{ marginBottom: "1rem", color: "#004276" }}>Original Report</h3>
            {fileType === "image" ? (
              <img
                src={fileUrl}
                alt="File Preview"
                style={{ maxWidth: "100%", height: "auto" }}
              />
            ) : fileType === "pdf" ? (
              <div style={{ height: "80vh", overflow: "auto" }}>
                <iframe
                  src={fileUrl}
                  style={{ height: "100%", width: "100%", border: "none" }}
                  title="PDF Viewer"
                />
              </div>
            ) : (
              <p>Unsupported file format</p>
            )}
          </SplitterPanel>
          <SplitterPanel className="flex align-items-center justify-content-center">
            {isVerified === 1 ? (
              <>
                <h3 style={{ marginBottom: "1rem", color: "#004276" }}>Smart Report</h3>
                <iframe
                  src={fileUrl1}
                  title="Smart Report"
                  style={{ width: "100%", height: "80vh", border: "none" }}
                />
              </>
            ) : (
              <>
              <div
                style={{
                  display: "flex",
                  gap: "20px",
                  marginBottom: "1rem",
                  padding: "10px",
                  backgroundColor: "#f9f9f9",
                  border: "1px solid #ccc",
                  borderRadius: "5px",
                  width: "100%",
                  fontSize: "14px",
                  flexWrap: "wrap",
                  opacity: isVerified === 2 ? 0.6 : 1,
                  pointerEvents: isVerified === 2 ? "none" : "auto",
                }}
              >
                <div style={{ flex: 1, minWidth: "250px" }}>
                  <label style={{ display: "block", marginBottom: "5px" }}>
                    <strong>Collection Date & Time:</strong>
                  </label>
                  <input
                    type="text"
                    value={smartDoc?.dateTime?.collection_date_time || ""}
                    onChange={(e) =>
                      setSmartDoc({
                        ...smartDoc,
                        dateTime: {
                          ...smartDoc.dateTime,
                          collection_date_time: e.target.value,
                        },
                      })
                    }
                    style={{
                      width: "100%",
                      padding: "8px",
                      borderRadius: "4px",
                      border: "1px solid #ccc",
                    }}
                  />
                </div>

                <div style={{ flex: 1, minWidth: "250px" }}>
                  <label style={{ display: "block", marginBottom: "5px" }}>
                    <strong>Received Date & Time:</strong>
                  </label>
                  <input
                    type="text"
                    value={smartDoc?.dateTime?.received_date_time || ""}
                    onChange={(e) =>
                      setSmartDoc({
                        ...smartDoc,
                        dateTime: {
                          ...smartDoc.dateTime,
                          received_date_time: e.target.value,
                        },
                      })
                    }
                    style={{
                      width: "100%",
                      padding: "8px",
                      borderRadius: "4px",
                      border: "1px solid #ccc",
                    }}
                  />
                </div>
              </div>
          



            <table
              border="1"
              cellPadding="10"
              cellSpacing="0"
              style={{
                borderCollapse: "collapse",
                width: "100%",
                textAlign: "center",
                backgroundColor: "white",
                boxShadow: "0px 5px 10px rgba(0, 0, 0, 0.2)",
                 opacity: isVerified === 2 ? 0.6 : 1,
        pointerEvents: isVerified === 2 ? "none" : "auto",
              }}
            >
              <thead>
                <tr style={{ backgroundColor: "#4CAF50", color: "white" }}>
                  <th>Name</th>
                  <th>Value</th>
                  <th>Unit</th>
                  <th>Reference Range</th>
                  <th>Flag</th>
                  <th>Delete</th>
                </tr>
              </thead>
              <tbody>
                {smartDoc?.smartDoc?.map((row, index) => (
                  <tr
                    style={{
                      backgroundColor: index % 2 === 0 ? "#e8f5e9" : "#f1f8e9",
                      transition: "background-color 0.3s ease",
                    }}
                    key={index}
                  >
                    <td style={{ fontWeight: "bold", color: "#388E3C" }}>
                      {" "}
                      <input
                        type="text"
                        value={row.name}
                        onChange={(e) =>
                          handleInputChange(index, "name", e.target.value)
                        }
                        style={{
                          padding: "5px",
                          borderRadius: "4px",
                          border: "1px solid #ccc",
                        }}
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        value={row.value}
                        onChange={(e) =>
                          handleInputChange(index, "value", e.target.value)
                        }
                        style={{
                          padding: "5px",
                          borderRadius: "4px",
                          border: "1px solid #ccc",
                          width: "80px",
                        }}
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        value={row.unit}
                        onChange={(e) =>
                          handleInputChange(index, "unit", e.target.value)
                        }
                        style={{
                          padding: "5px",
                          borderRadius: "4px",
                          border: "1px solid #ccc",
                          width: "100px",
                        }}
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        value={row.reference_range}
                        onChange={(e) =>
                          handleInputChange(
                            index,
                            "reference_range",
                            e.target.value
                          )
                        }
                        style={{
                          padding: "5px",
                          borderRadius: "4px",
                          border: "1px solid #ccc",
                          width: "100px",
                        }}
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        value={row.flag}
                        onChange={(e) =>
                          handleInputChange(index, "flag", e.target.value)
                        }
                        style={{
                          padding: "5px",
                          borderRadius: "4px",
                          border: "1px solid #ccc",
                          width: "80px",
                        }}
                      />
                    </td>
                    <td>
                      <Button
                        icon="pi pi-trash"
                        severity="danger"
                        onClick={() => handleDeleteRow(index)}
                        size="small"
                        text
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            </>
              )}
          </SplitterPanel>
        </Splitter>
      </Dialog>
    </div>
  );
}

export default MedicineOrderList;
